import axios from "axios"

export const api = axios.create({
  baseURL: "https://jzq9q876p3.execute-api.ap-southeast-2.amazonaws.com/UAT",
  headers: {}
})
